import {IPurchased} from "../../membership/purchased-products/interfaces";
import {FreePluginsDM} from "../interfaces";
import {cloneDeep} from "lodash";
import {rootActions} from "../DAL/store";

/**
 * Function that filters the free plugin items by Product I Own & filterTerm (text search)
 * */
export const getFilteredItems = (hideProductsOwn:boolean,purchased:IPurchased|null,freePlugins : FreePluginsDM[],filterTerm:string) => {
    //filter by filterTerm first
    let filteredItems = cloneDeep(freePlugins);
    if(filterTerm !== null && filterTerm.length > 0){
        filteredItems = freePlugins.filter(plugin => plugin.documentName.toLowerCase().includes(filterTerm.toLowerCase()));
    }

    if (!hideProductsOwn || !purchased || !purchased.purchasedProducts || purchased.purchasedProducts.length <= 0) {
        //if no filter by products I own or no purchasedProducts --> filter by filterTerm only
        return filteredItems;
    }

    const filteredPurchased = [];
    const purchasedProducts = purchased.purchasedProducts || [];

    if(!filteredItems) return [];

    for(let item of filteredItems){

        const purchasedFound = purchasedProducts.find(p => p.skuNumber.toLowerCase() === item.skuNumber.toLowerCase());

        if(!purchasedFound || (purchasedFound && purchasedFound.contentType === 4)){
            filteredPurchased.push(item);
        }
    }

    return filteredPurchased;

}

/**
 * Function translates code received from server to string
 * @param {string} successCode
 * returns string reply
 * */
export const translateReply = (successCode : number) => {
    let replyText;
    switch (successCode) {
        case 0:
            replyText = 'ERROR_CODE_SUCCESS';
            break;
        case 99:
            replyText = 'ERROR_CODE_ERROR';
            break;
        case -1:
            replyText = 'ERROR_CODE_NOT_ACTIVE';
            break;
        case 2:
            replyText = 'ERROR_CODE_ALREADY_RECEIVED';
            break;
        case 3:
            replyText = 'ERROR_CODE_NOT_ELIGIBLE';
            break;
        case -4:
            replyText = 'ERROR_CODE_FAILED_PRODUCING_ZPS';
            break;
        case -5:
            replyText = 'ERROR_CODE_FAILED_SERIAL_REGISTRATION';
            break;
        case 4:
            replyText = 'ERROR_ITEM_CODE_NOT_ACTIVE';
            break;
        case 5:
            replyText = 'ERROR_MAX_PRICE_OVER';
            break;
    }
    return replyText;
}

export const closeEfsPopup = (dispatch:any) => {
    dispatch(
        rootActions.main({
            showEfsPopup: false
        })
    );
}

/**
 * Function validates if the current promo is still active or not
 * */
export const validateCurrentPromoActive = (isEnded : boolean) =>{
    if (isEnded){

        const promoEndedEl = document.getElementById('promoEndedID');

        if (promoEndedEl){
            promoEndedEl.innerHTML = "";
            let promoEndedPar = document.createElement('p');
            promoEndedPar.textContent = 'This promo has ended';
            promoEndedPar.classList.add('font-bold');
            promoEndedPar.style.cssText='margin-bottom:0.25rem';
            promoEndedEl.appendChild(promoEndedPar);
            let chooseFreePluginsPar = document.createElement('p');
            chooseFreePluginsPar.textContent = 'You can still choose your free plugins below.';
            promoEndedEl.appendChild(chooseFreePluginsPar);
            promoEndedEl.classList.remove('hidden');
        }
    }
}